import { formatCurrency } from '@if/core/utils'
import { Stack, Typography } from '@mui/material'
import { getContractExpirationDate } from '@src/data/creditapp-selectors'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: CreditApplication
  isExpiryFeatureActive?: boolean
}
const ContractInformation = ({ creditApp, isExpiryFeatureActive = false }: Props) => {
  const { t } = useTranslation()
  const expiresAt = isExpiryFeatureActive ? getContractExpirationDate(creditApp) : null
  const isExpired = expiresAt != null && expiresAt < new Date()
  const expirationDateText = expiresAt
    ? expiresAt.toISOString().slice(0, 10)
    : null
  const paymentFrequency = creditApp.worksheet?.paymentFrequency
    ? t(`EPaymentFrequency.${creditApp.worksheet.paymentFrequency}`, { ns: 'enum' })
    : null

  const paymentAmountForFrequency = creditApp.worksheet?.paymentAmountForFrequency
    ? formatCurrency(creditApp.worksheet?.paymentAmountForFrequency)
    : null
  const loanTerm = creditApp.worksheet?.term ? `${creditApp.worksheet?.term} ${t('common.months')}` : null
  return (
    <div>
      <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
        <Stack direction="column">
          <Typography sx={{ fontSize: '0.8rem' }} variant="subtitle1">
            {t('worksheet.activationDate')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: '0.8rem' }}>{creditApp.worksheet?.deliveryOn}</Typography>

          <Typography sx={{ fontSize: '0.8rem' }} variant="subtitle1">
            {t('worksheet.paymentFrequency')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: '0.8rem' }}>{paymentFrequency}</Typography>

          <Typography sx={{ fontSize: '0.8rem' }} variant="subtitle1">
            {t('worksheet.firstPaymentOn')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: '0.8rem' }}>
            {creditApp.worksheet?.firstPaymentOn && creditApp.worksheet.firstPaymentOn}
          </Typography>
        </Stack>

        <Stack direction="column">
          <Typography sx={{ fontSize: '0.8rem' }} variant="subtitle1">
            {t('worksheet.loanTerm')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: '0.8rem' }}>{loanTerm}</Typography>

          <Typography sx={{ fontSize: '0.8rem' }} variant="subtitle1">
            {t('worksheet.paymentAmount')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: '0.8rem' }}>{paymentAmountForFrequency}</Typography>

          <Typography sx={{ fontSize: '0.8rem' }} variant="subtitle1">
            {t('worksheet.requestedAmount')}
          </Typography>
          <Typography sx={{ mb: 2, fontSize: '0.8rem' }}>
            {formatCurrency(creditApp.worksheet?.amountRequested)}
          </Typography>
        </Stack>
      </Stack>
      {expirationDateText && (
        <Stack direction="row">
          <Typography sx={{ fontSize: '0.8rem', mr: 1 }} variant="subtitle1">
            {isExpired ? t('worksheet.expiredOn') : t('worksheet.expiresOn')}
          </Typography>
          <Typography sx={{ fontSize: '0.8rem' }}>{expirationDateText}</Typography>
        </Stack>
      )}
    </div>
  )
}

export default ContractInformation
